/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

import ServicePath from "@/core/ServicePath"
import {
   MainRequest
} from "@/core/request";

export default class StockRequest extends MainRequest {


   static listAllByBranchOffice(data) {
      return this.postSEC(ServicePath.STOCK_BY_BRANCH_OFFICE, data);
   }
   static listAllWarehouseOutputByBranchOffice(data) {
      return this.postSEC(ServicePath.STOCK_WAREHOUSE_OUTPUT_BY_BRANCH_OFFICE, data);
   }

   static addEntry(object) {
      return this.postSEC(ServicePath.STOCK_ADD_ENTRY, object);
   }

   static addOutput(object) {
      return this.postSEC(ServicePath.STOCK_ADD_OUTPUT, object);
   }

   static getWarehouseOutput(object) {
      return this.postSEC(ServicePath.STOCK_WAREHOUSE_OUTPUT_BY_ID, object);
   }

   static add(object) {
      return this.postSEC(ServicePath.MODULE_ADD, object);
   }


   static update(object) {
      return this.postSEC(ServicePath.MODULE_UPDATE, object);
   }

   static get(object) {
      return this.postSEC(ServicePath.MODULE_GET, object);
   }

   static delete(object) {
      return this.postSEC(ServicePath.MODULE_DELETE, object);
   }

   static listAllByPrescriptionAndBranchOffice(data) {
      return this.postSEC(ServicePath.STOCK_BY_PRESCRIPTION_AND_BRANCH_OFFICE, data);
   }

   static stockHistory(data) {
      return this.postSEC(ServicePath.STOCK_HISTORY, data)
   }

   static updateQuantity(data) {
      return this.postSEC(ServicePath.STOCK_UPDATE_QUANTITY, data)
   }
   static findById(data) {
      return this.postSEC(ServicePath.STOCK_BY_ID, data)
   }



}